module.exports = __webpack_public_path__ + "img/github.02e85c27.png";